import { Injectable } from '@angular/core';

export interface PlaceSuggestion {
  placeId: string;
  description: string;
  placePrediction: google.maps.places.PlacePrediction;
}

@Injectable({ providedIn: 'root' })
export class PlacesAutocompleteService {

  newSessionToken(): google.maps.places.AutocompleteSessionToken {
    return new google.maps.places.AutocompleteSessionToken();
  }

  fetchSuggestions(
    input: string,
    options?: {
      locationBias?: google.maps.CircleLiteral;
      sessionToken?: google.maps.places.AutocompleteSessionToken;
    },
  ): Promise<PlaceSuggestion[]> {
    return google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input,
      ...options,
    }).then(({ suggestions }) =>
      suggestions.map((s) => ({
        placeId: s.placePrediction.placeId,
        description: s.placePrediction.text.text,
        placePrediction: s.placePrediction,
      })),
    );
  }
}
